import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseLayer from "../core/BaseLayer";
import LineModels from "./models";

var LineLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(LineLayer, _BaseLayer);

  var _super = _createSuper(LineLayer);

  function LineLayer() {
    var _this;

    _classCallCheck(this, LineLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", 'LineLayer');

    _defineProperty(_assertThisInitialized(_this), "arrowInsertCount", 0);

    _defineProperty(_assertThisInitialized(_this), "defaultSourceConfig", {
      data: [{
        lng1: 100,
        lat1: 30.0,
        lng2: 130,
        lat2: 30
      }],
      options: {
        parser: {
          type: 'json',
          x: 'lng1',
          y: 'lat1',
          x1: 'lng2',
          y1: 'lat2'
        }
      }
    });

    return _this;
  }

  _createClass(LineLayer, [{
    key: "buildModels",
    value: function () {
      var _buildModels = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var shape;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shape = this.getModelType();
                this.layerModel = new LineModels[shape](this);
                _context.next = 4;
                return this.initLayerModels();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildModels() {
        return _buildModels.apply(this, arguments);
      }

      return buildModels;
    }()
  }, {
    key: "getDefaultConfig",
    value: function getDefaultConfig() {
      var type = this.getModelType();
      var defaultConfig = {
        line: {},
        linearline: {},
        simple: {},
        wall: {},
        arc3d: {
          blend: 'additive'
        },
        arc: {
          blend: 'additive'
        },
        greatcircle: {
          blend: 'additive'
        },
        tileLine: {},
        halfLine: {},
        earthArc3d: {}
      };
      return defaultConfig[type];
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      var _shapeAttribute$scale;

      if (this.layerType) {
        return this.layerType;
      }

      var shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');
      var shape = shapeAttribute === null || shapeAttribute === void 0 ? void 0 : (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field;
      return shape || 'line';
    }
  }, {
    key: "processData",
    value: function processData(filterData) {
      // simple line 在接受 multiPolygon 的数据进行绘制的时候需要对数据进行拆解
      if (this.getModelType() !== 'simple') {
        return filterData;
      }

      var dataArray = [];
      filterData.map(function (data) {
        if (Array.isArray(data.coordinates) && Array.isArray(data.coordinates[0]) && Array.isArray(data.coordinates[0][0])) {
          var object = _objectSpread({}, data);

          data.coordinates.map(function (d) {
            dataArray.push(_objectSpread(_objectSpread({}, object), {}, {
              coordinates: d
            }));
          });
        } else {
          dataArray.push(data);
        }
      });
      return dataArray;
    }
  }]);

  return LineLayer;
}(BaseLayer);

export { LineLayer as default };